import styled from 'styled-components'
import { Container } from 'reactstrap'

export default styled(Container).attrs({ fluid: true, as: 'footer' })`
  padding: 40px 0 30px 0;
  background: #f3f3f3;
  font-size: 15px;
  color: #1c1c1c;
`
